import axios, {AxiosResponse} from "axios";
import {SERVICE_ENDPOINT, SERVICE_INVOICE_ENDPOINT} from "@/constants/endpoints";
import {
    CreateInvoicePayload, Summary,
    ServiceInvoice,
    ServiceInvoiceFilter, UpdateDraftInvoicePayload, UpdateInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import authHeader from "@/services/auth-header";
import Page from "@/dto/taxation/Page";
import QueryUtils from "@/utils/QueryUtils";

class ServiceInvoiceOrchestrator {

    public createInvoice(req: CreateInvoicePayload) {
        return axios.post<void>(`${SERVICE_INVOICE_ENDPOINT}`, req, {headers: authHeader()})
    }

    public getPageByFilter(filter: ServiceInvoiceFilter) {
        const query = QueryUtils.objectToQueryString(filter);
        return axios.get<Page<ServiceInvoice>>(`${SERVICE_INVOICE_ENDPOINT}${query}`, {headers: authHeader()})
    }

    public getAllByFilter(filter: ServiceInvoiceFilter) {
        const query = QueryUtils.objectToQueryString(filter);
        return axios.get<Array<ServiceInvoice>>(`${SERVICE_INVOICE_ENDPOINT}/all${query}`, {headers: authHeader()})
    }

    public changeStatus(req: UpdateInvoicePayload) {
        return axios.put(`${SERVICE_INVOICE_ENDPOINT}`, req, {headers: authHeader()})
    }

    public getInvoiceSummary(participantId: number) {
        return axios.get<Summary>(`${SERVICE_INVOICE_ENDPOINT}/summary/${participantId}`, {headers: authHeader()})
    }

    public deleteDraftInvoice(id: number): Promise<AxiosResponse<void>> {
        console.log("delete")
        return axios.delete<void>(`${SERVICE_INVOICE_ENDPOINT}/draft/${id}`, {headers: authHeader()})
    }

    public getBillSummary(participantId: number) {
        return axios.get<Summary>(`${SERVICE_ENDPOINT}/bills/summary/${participantId}`, {headers: authHeader()})
    }

    public draftInvoice(req: CreateInvoicePayload) {
        return axios.post<void>(`${SERVICE_INVOICE_ENDPOINT}/draft`, req, {headers: authHeader()})
    }

    public updateDraftInvoice(req: UpdateDraftInvoicePayload) {
        return axios.put<void>(`${SERVICE_INVOICE_ENDPOINT}/draft`, req, {headers: authHeader()})
    }


}

export default new ServiceInvoiceOrchestrator()